import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory, useNavigate } from "react-router-dom";
import "./manageradd.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import axios from "axios";
//import Navbar from "../common/Navbar";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "../BDO/dob.css";
import DatePicker from "react-date-picker";
import { APIURL } from "../../Global";
import { useAlert } from "react-alert";
import Select from 'react-select';
import SubmitConfirmationPopup from "../common/SubmitConfirm";
import { ConfirmationContext } from "../contexts/SubmitConfirmationContext";
//import HospitalNavbar from "../HospitalNavbar/HospitalNavbar";
//import BackButton from "../common/BackButton";

function Manageradd() {
  const [managerDatas, setManagerDatas] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    code: "",
    email: "",
    country: "India",
    state: "",
    location: "",
    specializations: [],
    qualification: [],
    department: [],
    dob: "",
    gender: "",
  });

  const [error, setError] = useState({
    email: "",
    phone: "",
  });

  //const [dobValue, setDobValue] = useState();
  const [dobValue, setDobValue] = useState();
  const [, setFormattedDob] = useState("");
  const [validateRawPhoneMsg, setValidateRawPhoneMsg] = useState("");
  const [rawPhone, setRawPhone] = useState("");
  const [dialCode, setDialCode] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidPhone, setIsValidPhone] = useState(true);
  const alert = useAlert();
  const navigate = useNavigate();
  const [department, setDepartment] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([])
  const [showConfirmation, setShowConfirmation,closeConfirmationPopup] = useContext(ConfirmationContext);
  const inputRefs = useRef([])
  const submitButtonRef = useRef (null)
  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {       
      if(index === 5 ) {
        submitButtonRef.current.click();
      }else{
      e.preventDefault();    
      const nextIndex = index + 1;
      if (nextIndex < inputRefs.current.length && inputRefs.current[nextIndex]) {
        // move focus to the next input if it exists
        inputRefs.current[nextIndex].focus();
      }
    }
    }
  };
  const handleKey = (e) => {
    if (e.key === "Enter") {
      const activeElement = document.activeElement;
      if (
        !inputRefs.current.includes(activeElement) &&
        activeElement !== submitButtonRef.current
      ) {
        submitButtonRef.current.click();
      }
    }else if (e.altKey && e.key === 's') {
      console.log("hi")
      submitButtonRef.current.click();
    }else if (e.altKey && e.key === 'c') {
      navigate("../");
    }
  };

  useEffect(() => {
    
    document.addEventListener("keydown", handleKey);
  
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, []);

  useEffect(() => {
    const tokenString = sessionStorage.getItem("usertoken");

    let str = tokenString.replace(/["]+/g, "");
    axios

      .get(`${APIURL}/api/v1/service-provider/master-departments/`, {
        headers: {
          Authorization: "Token " + str,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          let data = []
          res.data.length > 0 && res.data.map((item) => {
            data = ([...data, { value: item.id, label: item.department_name }])
          })
          setDepartmentOptions(data)
          setDepartment([data[0]]);
          setManagerDatas(current => ({
            ...current,
            department: [1]
          }));

        } else {
          alert.error(res.data.message);
        }
      });
  }, []);
  
  const departmentChange = (selectedOptions) => {
    setError(currentState => ({
      ...currentState,
      department: ""
    }));
  
    if (!selectedOptions) {
      setDepartment([]);
      setManagerDatas(current => ({ ...current, department: [] }));
      return;
    }
  
    const selectedValues = selectedOptions.map(option => option.value);  
    setDepartment(selectedOptions);  
    setManagerDatas(current => ({
      ...current,
      department: selectedValues
    }));
  };
  
  const handleDOB = (date) => {
    
    setDobValue(date);

    let dateUpdated = date;
    if (date !== null) {
      const offset = date.getTimezoneOffset();

      dateUpdated = new Date(date.getTime() - offset * 60 * 1000);

      let DateExtracted = dateUpdated.toISOString().split("T")[0];
      //let datefinal = moment(DateExtracted).format('YYYY-MM-DD')  
      /*let dateString= DateExtracted.toString(); */
      setFormattedDob(DateExtracted);

      setManagerDatas((currentstate) => ({
        ...currentstate,
        dob: DateExtracted,
      }));
    }
    setError((currentstate) => ({
      ...currentstate,
      ["dob"]: "",
    }));
  };

  const handleGenderRadioButton = (e) => {
    let genderOpted = e.target.value;
    setManagerDatas((currentstate) => ({
      ...currentstate,
      gender: genderOpted,
    }));
    setError((currentstate) => ({
      ...currentstate,
      ["gender"]: "",
    }));
  };

  const handleConfirm = () => {
    
    handleSubmit();
  };

  const handleCancel = () => {
    closeConfirmationPopup()
  };

  const handleSubmit = () => {
    
    if (rawPhone !== null && rawPhone !== "" && rawPhone !== " ") {
      setValidateRawPhoneMsg("success");
      const tokenStr = sessionStorage.getItem("usertoken");

      if (tokenStr) {
        const v = tokenStr;
        let v2 = v.replace(/["]+/g, "");
        let dataToSend={}
        dataToSend = {
          name: managerDatas.firstname + " " + managerDatas.lastname,
          location: managerDatas.location,
          state: managerDatas.state,
          country: managerDatas.country,
          specializations: managerDatas.specializations,
          email: managerDatas.email,
          qualification: managerDatas.qualification,
          phone: managerDatas.phone,
          code: managerDatas.code,
          department: managerDatas.department,
          dob: managerDatas.dob,
          gender: managerDatas.gender,
      }
        axios
          .post(`${APIURL}/api/v1/service-provider/manager/`, dataToSend, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + v2,
            },
          })
          .then((res) => {
            if (res.data.status === "success") {
              alert.success('Added successfully!');
              sessionStorage.setItem("managername", res.data.name);
              navigate('/manager-list');
            } else {
              closeConfirmationPopup();
              alert.error(
                res.data.message ? res.data.message : "Error in submission"
              ); 
            }
          })
          .catch((err) => {
            closeConfirmationPopup();
            alert.error("Error in submission. Try again!")
          });
      }
    } else {
      closeConfirmationPopup();
      setValidateRawPhoneMsg("error");
    }
  };

  const handleCheckEmail = (e) => {
    e.preventDefault();
    const val = e.target.value;
    const key = e.target.name;

    setManagerDatas((currentstate) => ({
      ...currentstate,
      [key]: val,
    }));

    setIsValidEmail(true);
    
    if (val !== "") {
      setError((currentstate) => ({
        ...currentstate,
        email: "",
      }));

      var pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );
        if (pattern.test(val)) {

      const data = {
        [key]: val,
      };

      axios
        .post(`${APIURL}/api/v1/account/check-user/`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.status === "success") {
            if (res.data.is_existing_user === true) {
              setError((currentstate) => ({
                ...currentstate,
                [key]: `This ${key} is already registered!`,
              }));
              setIsValidEmail(false);
            } else {
              setIsValidEmail(true);
            }
          } else {
            setIsValidEmail(true);
          }
        })
        .catch((err) => {});
    }}
  };

  const handleCheckExistingPhone = (e) => {
    setIsValidPhone(true);
    if (e.target.value !== "") {
      setError((currentstate) => ({
        ...currentstate,
        phone: "",
      }));

      const data = {
        code: dialCode,
        mobile_number: rawPhone,
      };

      axios
        .post(`${APIURL}/api/v1/account/check-user/`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.status === "success") {
            if (res.data.is_existing_user === true) {
              setError((currentstate) => ({
                ...currentstate,
                phone: "This phone number is already registered!",
              }));
              setIsValidPhone(false);
            } else {
              setIsValidPhone(true);
            }
          } else {
            setIsValidPhone(true);
          }
        })
        .catch((err) => {});
    }
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    
    if (validate() && isValidEmail && isValidPhone) {
      setShowConfirmation(true);
    }
  };

  const handleChange = (e) => {
    
    e.preventDefault();
    const val = e.target.value;
    const key = e.target.name;

    setManagerDatas((currentstate) => ({
      ...currentstate,
      [key]: val,
    }));
    setError((currentstate) => ({
      ...currentstate,
      [key]: "",
    }));
  };

  const handleQualification = (e) => {
    e.preventDefault();
    const val = e.target.value;

    const key = e.target.name;
    let arr = [];
    if (val && val.includes(",")) {
      arr = val.split(",");
    } else {
      arr.push(val);
    }
    setManagerDatas((currentstate) => ({
      ...currentstate,
      [key]: arr,
    }));
    setError((currentstate) => ({
      ...currentstate,
      "qualification": "",
    }));
  };

  // const handleSpecialization = (e) => {
  //   e.preventDefault();
  //   const val = e.target.value;

  //   const key = e.target.name;
  //   let arr = [];
  //   if (val && val.includes(",")) {
  //     arr = val.split(",");
  //   } else {
  //     arr.push(val);
  //   }
  //   setManagerDatas((currentstate) => ({
  //     ...currentstate,
  //     [key]: arr,
  //   }));
  // };

  const handleCountry = (val) => {
    setManagerDatas((currentstate) => ({
      ...currentstate,
      country: val,
    }));
  };

  const handleRegion = (val) => {
    setManagerDatas((currentstate) => ({
      ...currentstate,
      state: val,
    }));
    setError((currentstate) => ({
      ...currentstate,
      ["state"]: "",
    }));
  };

  const handlePhoneInput = (value, data, event, formattedValue) => {
    setRawPhone(value.slice(data.dialCode.length));
    setDialCode(value.slice(0, data.dialCode.length));
    setManagerDatas((currentstate) => ({
      ...currentstate,
      phone: value.slice(data.dialCode.length),
      code: value.slice(0, data.dialCode.length),
    
    }));
    setError((currentstate) => ({
      ...currentstate,
      "phone": "",
    }));
  };

  const validate = () => {
    let input = managerDatas;
    let errors = {};
    let isValid = true;
    setError({});

    if (!input["firstname"] || input["firstname"] === "") {
      isValid = false;
      errors["firstname"] = "Enter first name";
    }

    if (!input["lastname"] || input["lastname"] === "") {
      isValid = false;
      errors["lastname"] = "Enter last name";
    }

    if (!input["department"] || input["department"].length === 0 || input["department"][0] === "" ) {
      isValid = false;
      errors["department"] = "Select department";
    }

    if (!input["location"] || input["location"] === "") {
      isValid = false;
      errors["location"] = "Enter location";
    }

    if (!input["country"] || input["country"] === "") {
      isValid = false;
      errors["country"] = "Select a country";
    }

    if (!input["state"] || input["state"] === "") {
      isValid = false;
      errors["state"] = "Select a state";
    }

    if (
      !input["qualification"] ||
      input["qualification"].length === 0 ||
      input["qualification"][0] === ""
    ) {
      isValid = false;
      errors["qualification"] = "Enter qualification";
    }

 


    if (!dialCode || dialCode === "" || !rawPhone || rawPhone === "") {
      isValid = false;
      errors["phone"] = "Enter phone number";
    }

    if (
      typeof dobValue == "undefined" ||
      dobValue === "" ||
      dobValue === null
    ) {
      isValid = false;
      errors["dob"] = "Enter your date of birth";
    }
    if (
      typeof managerDatas.gender == "undefined" ||
      managerDatas.gender === "" ||
      managerDatas.gender === null
    ) {
      isValid = false;
      errors["gender"] = "Select gender";
    }

    if (typeof input["email"] !== "undefined") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(input["email"])) {
        isValid = false;
        errors["email"] = "Enter a valid email address.";
      }
    }
    if (typeof input["qualification"] !== "undefined") {
      var pattern2 = new RegExp(/[`!@#$%^&*()_+\=\[\]{};':"\\|<>\/?~]/);
      if (pattern2.test(input["qualification"])) {
        isValid = false;
        errors["qualification"] = "Check the characters used";
      }
    }
    if (typeof input["department"] !== "undefined") {
      var pattern2 = new RegExp(/[`!@#$%^&*()_+\=\[\]{};':"\\|<>\/.?~]/);
      if (pattern2.test(input["department"])) {
        isValid = false;
        errors["department"] = "Check the characters used";
      }
    }
    if (typeof input["firstname"] !== "undefined") {
      var pattern1 = new RegExp(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/.?~]/);
      if (pattern1.test(input["firstname"])) {
        isValid = false;
        errors["firstname"] = "Special Characters are not allowed";
      }
    }

    if (input["firstname"] && typeof input["firstname"] !== "undefined") {
      if (input["firstname"].length > 0 && input["firstname"].length < 3) {
        isValid = false;
        errors["firstname"] = "Must contain atleast 3 characters";
      }
    }

    if (typeof input["lastname"] !== "undefined") {
      var pattern2 = new RegExp(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/.?~]/);
      if (pattern2.test(input["lastname"])) {
        isValid = false;
        errors["lastname"] = "Special Characters are not allowed";
      }
    }

    if (!input["email"]) {
      isValid = false;

      errors["email"] = "Enter email address.";
    }

    if (isValidPhone === false) {
      isValid = false;
      errors["phone"] = "Phone number already registered!";
    }

    if (rawPhone.length > 0 && rawPhone.length < 10) {
      isValid = false;
      errors["phone"] = "Pheck numbers ";
    }
    if (isValidEmail === false) {
      isValid = false;
      errors["email"] = "Email already registered!";
    }

    setError((currentstate) => ({
      ...currentstate,
      ...errors,
    }));

    return isValid;
  };


  return (
    <div className="add-dr-page">
 

      <div className="add-dr-form-holder">

        <div className="quick-links">
          <Link to="/manager-list">
            <button type="button" className="btn btn-primary btn-col dr-btn">
              {" "}
              Goto Manager List{" "}
            </button>
          </Link>
        </div>
        <form className="add-dr-form" onSubmit={handleContinue}>
          <h4 className="title-of-page"> Add Manager Details</h4>
          <div className="add-dr-div">
            <div className="form-group col-lg-6 item-left-row">
              <label className="">* First Name: </label>
              <input
                ref={el => inputRefs.current[0] = el}
                onKeyDown={(e) =>handleKeyDown(e,0)}
                className="form-control"
                type="text"
                maxLength="50"
                placeholder=""
                name="firstname"
                onChange={handleChange}
              />
              {error.firstname ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {error.firstname}
                </div>
              ) : null}
            </div>
            <div className="form-group col-lg-6 item-left-row">
              <label className="">* Last Name: </label>

              <input
                ref={el => inputRefs.current[1] = el}
                onKeyDown={(e) =>handleKeyDown(e,1)}
                className="form-control"
                type="text"
                maxLength="50"
                placeholder=""
                name="lastname"
                onChange={handleChange}
              />
              {error.lastname ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {error.lastname}
                </div>
              ) : null}
            </div>
            <div className="form-group col-lg-6 item-left-row">
              <label className="">* Email Address: </label>

              <input
                ref={el => inputRefs.current[2] = el}
                onKeyDown={(e) =>handleKeyDown(e,2)}
                className="form-control "
                type="email"
                maxLength="50"
                placeholder=""
                name="email"
                onChange={handleCheckEmail}
              />
              {error.email ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {" "}
                  {error.email}
                </div>
              ) : null}
            </div>
            <div className="form-group col-lg-6 item-left-row">
              <label className="">* Phone: </label>

              <PhoneInput
                inputProps={{
                  ref: el => inputRefs.current[3] = el,
                  tabIndex: 0,
                  onKeyDown: e => handleKeyDown(e, 3),
                }}
                country={"in"}
                onlyCountries={['in']}
                countryCodeEditable={false}
                onChange={handlePhoneInput}
                onBlur={handleCheckExistingPhone}
              />
              {error.phone ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {" "}
                  {error.phone}
                </div>
              ) : null}
            </div>

            <div className="form-group col-lg-6 item-left-row">
              <label className="">* Qualifications: </label>

              <input
                ref={el => inputRefs.current[4] = el}
                onKeyDown={(e) =>handleKeyDown(e,4)}
                className="form-control"
                type="text"
                maxLength="150"
                placeholder=""
                name="qualification"
                onChange={handleQualification}
              />
              {error.qualification ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {error.qualification}
                </div>
              ) : null}
            </div>
            <div className="form-group col-lg-6 item-left-row">
              <label className=""> * Location/ City : </label>

              <input
                ref={el => inputRefs.current[5] = el}
                onKeyDown={(e) =>handleKeyDown(e,5)}
                className="form-control"
                type="text"
                maxLength="50"
                placeholder=""
                name="location"
                onChange={handleChange}
              />
              {error.location ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {error.location}
                </div>
              ) : null}
            </div>
            <div className="form-group col-lg-6 item-left-row">
              <label className="">*Access Departments: </label>
              <Select
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '44px',
                    border: '1px solid #E3E3E3',
                  })
                }}
                isMulti
                value={department}
                onChange={(data, e) => {
                  departmentChange(data, e);
                }}
                options={departmentOptions}
                name="department"
              />
              {error.department ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {error.department}
                </div>
              ) : null}
            </div>
            <div className="form-group col-lg-6 region-selector-dr">
              <label className="">* State: </label>

              <RegionDropdown
              defaultOptionLabel={'Select State'}
                country={managerDatas.country}
                value={managerDatas.state}
                onChange={(val) => handleRegion(val)}
              />
              {error.state ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {" "}
                  {error.state}
                </div>
              ) : null}                         
            </div>
            <div className="form-group dob-check col-lg-6">
              <div className="dob-container form-control">
                <span>Date of Birth * : </span>
                <DatePicker
                onChange={date => { handleDOB(date) }}

                maxDate={new Date()}
                value={dobValue}

              />
              </div>
              {error.dob ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {" "}
                  {error.dob}
                </div>
              ) : null}
            </div>

            <div className="form-group gender-radio-check col-lg-6">
              <div className="form-control">
                <span>*Gender:</span>&nbsp;
                <input
                  type="radio"
                  id="male"
                  name="gender"
                  value="male"
                  checked={managerDatas.gender === "male"}
                  onChange={handleGenderRadioButton}
                />
                <label htmlFor="male">Male</label>

                <input
                  type="radio"
                  id="female"
                  name="gender"
                  value="female"
                  checked={managerDatas.gender === "female"}
                  onChange={handleGenderRadioButton}
                />

                <label htmlFor="female">Female</label>

                <input
                  type="radio"
                  id="others"
                  name="gender"
                  value="others"
                  checked={managerDatas.gender === "others"}
                  onChange={handleGenderRadioButton}
                />
                <label htmlFor="others">Other</label>
              </div>
              {error.gender ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {" "}
                  {error.gender}
                </div>
              ) : null}
            </div>

            <div className="form-group col-lg-6 country-selector-dr">
              <label className="">Country: </label>
                <input
                  className="form-control"
                  type="text"
                  value={managerDatas.country}
                  maxLength="150"
                  disabled={true}
                />
              {/* <CountryDropdown
               disabled={true}
              
                value={managerDatas.country}
                onChange={(val) => handleCountry(val)}
              /> */}
              {error.country ? (
                <div
                  style={{ zIndex: "auto" }}
                  className="error-validation-msg"
                >
                  {" "}
                  {error.country}
                </div>
              ) : null}
            </div>
          </div>
          <div className="form-button">
          <button type="submit"  ref={submitButtonRef} className="btn btn-primary btn-col">
            {" "}
            Submit
          </button>{" "}
          </div>
          <br />
          <br />
          <h6 className="text-muted">All fields marked * are mandatory</h6>
        </form>

        {/************************Unused***************
    {(() => {
      switch(submitMsg){
      case "success":
      return   (
          <div>
            <h5 style={{ color: "green" }}> Data submitted sucessfully !!</h5>{" "}

            


            <br />
            <br />
           
          
            
          </div>
        );

        case "error": 
        return (
          <h5 style={{ color: "red" }}>
            
            Error in data submission.Please check again!
          </h5>
        );
        default: 
        return "";
           }
      })()}

    *************************/}

        {validateRawPhoneMsg === "error" ? (
          <h5 style={{ color: "red" }}>Phone number field is mandatory!</h5>
        ) : (
          ""
        )}
      </div>
      {showConfirmation && (
      <SubmitConfirmationPopup
        message="Are you sure you want to submit the form?"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    )}
    </div>
  );
}

export default Manageradd;
